import axios from 'axios';
import { UserState } from '../store/UserState';
import { useNavigate } from 'react-router-dom';

import { EncryptDecryptService } from './EncryptDecryptService';
import { useEffect, useState } from 'react';

export function ChartstwitsRepository() {
  const chartTwitsApi = 'http://49.206.197.126:44335/api/';
  const chartTwitsImagePath = "http://49.206.197.126:44335/Images/";
  const chartTwitsViewPath = "http://49.206.197.126:44335/Videos/";
  // const chartTwitsApi = 'http://192.168.0.177:44335/api/';
  // const chartTwitsImagePath = "http://192.168.0.177:44335/Images/";
  // const chartTwitsViewPath = "http://192.168.0.177:44335/Videos/";

  const encrydecry = EncryptDecryptService();

  const _fetch = async (url: any, options: any) => {

    debugger;
    try {
      if (url !== 'ForgotPasswordEmail.php') {
        if (options.method && options.method.toUpperCase() === 'POST' && options.body) {
          const encryptedData = encrydecry.encrypt(options.body);

          options.body = (encryptedData);
        }
        if (options.method.toUpperCase() === 'get' && url.includes('?')) {
          const encryptedParams = encrydecry.encrypt(url.substr(url.indexOf('?') + 1));
          url = `${url.substr(0, url.indexOf('?') + 1)}${encryptedParams}`;
        }
      }

      const response = await fetch(url, options);



      if (!response.ok) {
        console.log(JSON.stringify(response))
        throw new Error(`HTTP error! status: ${JSON.stringify(response.status)}`);
      }


      return response;
    } catch (error) {

      console.error('Error:', error);
      throw error;
    }
  };




  const userState = UserState();



  const viewCharts = async () => {
    try {


      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        body: JSON.stringify({ sfDetails: '' })
      };


      const response = await _fetch(`${chartTwitsApi}charttwits`, requestOptions);
      const responseData = await response.json();
      return responseData;





    } catch (error: any) {

      console.error('Error:', error);
      if (error.response && error.response.status === 401) {

        handleUnauthorized();
      }
    }
  }


  const viewTwits = async () => {
    try {

      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        body: JSON.stringify({ sfDetails: '' })
      };


      const response = await _fetch(`${chartTwitsApi}viewtwits`, requestOptions);
      const responseData = await response.json();
      return responseData;




    } catch (error: any) {

      console.error('Error:', error);
      if (error.response && error.response.status === 401) {

        handleUnauthorized();
      }
    }


  }


  const viewCatalysts = async () => {
    try {

      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        body: JSON.stringify({ sfDetails: '' })
      };


      const response = await _fetch(`${chartTwitsApi}catalyst`, requestOptions);
      const responseData = await response.json();
      return responseData;


    } catch (error: any) {

      console.error('Error:', error);
      if (error.response && error.response.status === 401) {

        handleUnauthorized();
      }
    }


  }

  const getdates = async () => {


    try {



      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        body: JSON.stringify({ sfDetails: '' })
      };


      const response = await _fetch(`${chartTwitsApi}getDatesFromCurrentDate`, requestOptions);
      const responseData = await response.json();
      return responseData;


    } catch (error: any) {

      console.error('Error:', error);
      if (error.response && error.response.status === 401) {

        handleUnauthorized();
      }
    }


  }

  const getStocks = async () => {

    try {

      debugger;

      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        body: JSON.stringify({ sfDetails: '' })
      };


      const response = await _fetch(`${chartTwitsApi}gettrendingstocks`, requestOptions);
      const responseData = await response.json();
      return responseData;


    } catch (error: any) {

      console.error('Error:', error);
      if (error.response && error.response.status === 401) {

        handleUnauthorized();
      }
    }
  }

  const getTodayStocks = async () => {

    try {

      debugger;

      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        body: JSON.stringify({ sfDetails: '' })
      };


      const response = await _fetch(`${chartTwitsApi}gettodaystocks`, requestOptions);
      const responseData = await response.json();
      return responseData;


    } catch (error: any) {

      console.error('Error:', error);
      if (error.response && error.response.status === 401) {

        handleUnauthorized();
      }
    }
  }

  const loginUser = async (loginDetails: any) => {
    try {
      debugger;


      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
        },
        body: JSON.stringify(loginDetails)
      };


      const response = await _fetch(`${chartTwitsApi}login`, requestOptions);
      const responseData = await response.json();

      if (responseData.length > 0) {
        userState.setUserState(responseData[0]);

      }


      return responseData;

    } catch (error: any) {
      debugger;
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }
  const handleUnauthorized = () => {
    userState.onLogOut();
  };

  const watchlist = async () => {
    debugger;
    try {
      debugger;
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        body: ''
      };
      debugger;
      const response = await _fetch(`${chartTwitsApi}watchlist`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }

  const getdatesforcatalyst = async () => {
    try {
      debugger;
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        body: JSON.stringify({ sfDetails: '' })
      };
      const response = await _fetch(`${chartTwitsApi}getdatesforcatalyst`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }


  const gethomedataForChartsandTwits = async (Details: any) => {
    debugger;
    try {
      debugger;
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        body: JSON.stringify(Details)
      };
      debugger;
      const response = await _fetch(`${chartTwitsApi}gethomescreendataforchartsandtwits`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }

  const saveChatReactions = async (d: any, e: any) => {
    debugger;

    let data = { 'ChartTwit_ID': d.Post_ID, 'View': 0, 'Like': (d.Liked == 0 ? 1 : 0), 'Share': 0, 'UpdatedDate': d.ReactionsUpdatedDate }

    try {
      debugger;
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        body: JSON.stringify(data)
      };
      debugger;
      const response = await _fetch(`${chartTwitsApi}chatReaction`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }

  const savePoints = async (d: any, e: any) => {
    debugger;
    let data = { 'post_ID': d.Post_ID, 'type': d.Type, 'postUserId': d.User_ID, 'points': e, 'UserId': userState.userStoreDetails.User_ID };
    debugger;
    try {
      debugger;
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        body: JSON.stringify(data)
      };
      debugger;
      const response = await _fetch(`${chartTwitsApi}savepoints`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }

  const saveChartComment = async (d: any) => {
    debugger;
    let data = { 'ChartTwit_ID': d.ChartTwit_ID, 'ChartComment': d.ChartComment, 'UserId': userState.userStoreDetails.User_ID };
    debugger;
    try {
      debugger;
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        body: JSON.stringify(data)
      };
      debugger;
      const response = await _fetch(`${chartTwitsApi}charttwitComment`, requestOptions);
      debugger;
      const responseData = await response.json();
      debugger;
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }

  // Bullish 
  const getTopGainers = async () => {
    debugger;
    try {
      debugger;
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        body: JSON.stringify({ sfDetails: '' })
      };
      debugger;
      const response = await _fetch(`${chartTwitsApi}gettopgainers`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }

  const getGapUpDetails = async () => {
    debugger;
    try {
      debugger;
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        // body: JSON.stringify({ sfDetails: '' })
      };
      debugger;
      const response = await _fetch(`${chartTwitsApi}getgapupdata`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }

  const getHighVolumeDetails = async () => {
    debugger;
    try {
      debugger;
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        // body: JSON.stringify({ sfDetails: '' })
      };
      debugger;
      const response = await _fetch(`${chartTwitsApi}gethighvolumestock`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }

  const getBullishBreakout = async () => {
    debugger;
    try {
      debugger;
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        // body: JSON.stringify({ sfDetails: '' })
      };
      debugger;
      const response = await _fetch(`${chartTwitsApi}bullishbreakout`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }

  const getUpTrendStock = async () => {
    debugger;
    try {
      debugger;
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        // body: JSON.stringify({ sfDetails: '' })
      };
      debugger;
      const response = await _fetch(`${chartTwitsApi}uptrendstock`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }

  const getNewHighs = async () => {
    debugger;
    try {
      debugger;
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        // body: JSON.stringify({ sfDetails: '' })
      };
      debugger;
      const response = await _fetch(`${chartTwitsApi}newhighs`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }


  // Bearish

  const getTopLosses = async () => {
    debugger;
    try {
      debugger;
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        body: JSON.stringify({ sfDetails: '' })
      };
      debugger;
      const response = await _fetch(`${chartTwitsApi}gettoplosses`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }

  const getBearishGapdown = async () => {
    debugger;
    try {
      debugger;
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        // body: JSON.stringify({ sfDetails: '' })
      };
      debugger;
      const response = await _fetch(`${chartTwitsApi}gapdown`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }

  const getBearishLowVolumeDetails = async () => {
    debugger;
    try {
      debugger;
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        // body: JSON.stringify({ sfDetails: '' })
      };
      debugger;
      const response = await _fetch(`${chartTwitsApi}lowvolume`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }

  const getBearishBreakoutDetails = async () => {
    debugger;
    try {
      debugger;
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        // body: JSON.stringify({ sfDetails: '' })
      };
      debugger;
      const response = await _fetch(`${chartTwitsApi}bearishbreakout`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }

  const getBearishDownTrendDetails = async () => {
    debugger;
    try {
      debugger;
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        // body: JSON.stringify({ sfDetails: '' })
      };
      debugger;
      const response = await _fetch(`${chartTwitsApi}bearishbreakout`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }

  const getBearishNewLowsDetails = async () => {
    debugger;
    try {
      debugger;
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        // body: JSON.stringify({ sfDetails: '' })
      };
      debugger;
      const response = await _fetch(`${chartTwitsApi}newlows`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }

  const viewCatalyst = async () => {
    debugger;
    try {
      debugger;
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        // body: JSON.stringify({ sfDetails: '' })
      };
      debugger;
      const response = await _fetch(`${chartTwitsApi}tickercatalyst`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }

  const getVolatileStock = async () => {
    debugger;
    try {
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        body: JSON.stringify({ sfDetails: '' })
      };
      const response = await _fetch(`${chartTwitsApi}getmostvolatiledetails`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }

  const getMostActive = async () => {
    debugger;
    try {
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        body: JSON.stringify({ sfDetails: '' })
      };
      const response = await _fetch(`${chartTwitsApi}getmostactive`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }

  const getInsiderDetails = async () => {
    debugger;
    try {
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        body: JSON.stringify({ sfDetails: '' })
      };
      const response = await _fetch(`${chartTwitsApi}getinsiderdetails`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }

  const getWictok = async () => {
    debugger;
    try {
      debugger;
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        // body: JSON.stringify({ sfDetails: '' })
      };
      debugger;
      const response = await _fetch(`${chartTwitsApi}getwictok`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }

  const Wicktocklikecomment = async (d: any) => {
    debugger;
    try {
      debugger;
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        body: d
      };
      debugger;
      const response = await _fetch(`${chartTwitsApi}Wicktocklikecomment`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }




  const getHistoricalData = async (d: any) => {
    debugger;

    let symbolDetails: any = { Symbol: d };
    // let symbolDetails: any = { Symbol: ticker };
    const currentDate = new Date();
    // Set the EndDate to the current date
    symbolDetails.EndDate = currentDate.toISOString().split('T')[0];

    // Set the StartDate to 5 years before the current date
    const startYear = currentDate.getFullYear() - 5;
    const startMonth = currentDate.getMonth() + 1; // Note: Months are zero-based
    const startDay = currentDate.getDate();

    symbolDetails.StartDate = `${startYear}-${startMonth.toString().padStart(2, '0')}-${startDay.toString().padStart(2, '0')}`;


    try {
      debugger;
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        body: JSON.stringify(symbolDetails)
      };
      debugger;
      const response = await _fetch(`${chartTwitsApi}gethistoricalstockinfobysymbol`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }
  }

  const getTickers = async (tickers: any) => {
    debugger;
    try {
      debugger;
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Issuer': 'ChartTwits'
          , 'Authorization': `Bearer ${userState.userStoreDetails.Token}`,
        },
        body: JSON.stringify(tickers)
      };
      debugger;
      const response = await _fetch(`${chartTwitsApi}gettickers`, requestOptions);
      const responseData = await response.json();
      return responseData;
    } catch (error: any) {
      console.error('Error:', error);
      if (error.response && error.response.status === 401) {
        handleUnauthorized();
      }
    }

  }



  return {
    getdatesforcatalyst, watchlist, getStocks, getdates, viewCatalysts, viewTwits, viewCharts, chartTwitsImagePath, chartTwitsViewPath, loginUser, getTodayStocks,
    gethomedataForChartsandTwits, saveChatReactions, savePoints, saveChartComment, getTopGainers, getGapUpDetails, getHighVolumeDetails, getBullishBreakout, getUpTrendStock, getNewHighs,

    getTopLosses, getBearishGapdown, getBearishLowVolumeDetails, getBearishBreakoutDetails, getBearishDownTrendDetails, getBearishNewLowsDetails,
    viewCatalyst, getVolatileStock, getMostActive, getInsiderDetails, getWictok, Wicktocklikecomment, chartTwitsApi, getHistoricalData,
    getTickers
  }
}